// src/pages/NotFound.jsx
import { useNavigate } from 'react-router-dom';
import { C } from '../styles/tokens';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div style={{ background: C.bg, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', textAlign: 'center', padding: '28px', position: 'relative', overflow: 'hidden' }}>
      <div className="grid-bg" />
      <div style={{ position: 'absolute', top: '30%', left: '50%', transform: 'translate(-50%,-50%)', width: '400px', height: '400px', borderRadius: '50%', background: `${C.violet}15`, filter: 'blur(80px)', pointerEvents: 'none' }} />

      <div style={{ position: 'relative', zIndex: 1 }}>
        <div className="syne" style={{ fontSize: 'clamp(6rem,15vw,10rem)', fontWeight: 800, lineHeight: 1, background: `linear-gradient(135deg,${C.magenta},${C.violet})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
          404
        </div>
        <h1 className="syne" style={{ fontSize: 'clamp(1.5rem,4vw,2.5rem)', fontWeight: 800, marginBottom: '12px', marginTop: '8px' }}>
          Page Not Found
        </h1>
        <p style={{ fontSize: '15px', color: 'rgba(255,255,255,.45)', marginBottom: '36px', maxWidth: '400px' }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div style={{ display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/')}
            style={{ padding: '13px 28px', background: `linear-gradient(135deg,${C.magenta},${C.violet})`, border: 'none', borderRadius: '9px', color: '#fff', fontSize: '14px', fontWeight: 700, cursor: 'pointer', fontFamily: "'Syne',sans-serif" }}
          >
            ← Go Home
          </button>
          <button
            onClick={() => navigate('/opportunities')}
            style={{ padding: '12px 26px', background: 'transparent', border: `1px solid rgba(254,52,232,.35)`, borderRadius: '9px', color: '#fff', fontSize: '14px', fontWeight: 600, cursor: 'pointer' }}
          >
            Browse Opportunities
          </button>
        </div>
      </div>
    </div>
  );
}
